import { AxiosInstance } from 'axios';
import { ICustomPlanReportsRepository } from '@/model/repository/manager/customPlanReports/CustomPlanReportsRepository';

export default (Repository: AxiosInstance) =>
  (resource: string): ICustomPlanReportsRepository => ({
    getCustomPlanReportsCountByTemplateId(payload) {
      return Repository.get(`${resource}`, { params: payload });
    },
  });
